import { createAsyncThunk } from "@reduxjs/toolkit";
import { InsightsHubArticle } from "@insightsHub/models";
import { openNotificationThunk } from "@store/Notification/thunks";
import { ThunkApiConfig } from "@shared/models/redux";
import { callInsightsHubArticleApi } from "@insightsHub/store/thunks/callInsightsHubArticleApi";
import { mapStrapiPortalArticle } from "@insightsHub/util/mapStrapiPortalArticle";
import { resolveInsightsHubArticleDocumentId } from "@insightsHub/util/resolveInsightsHubArticleDocumentId";

export const fetchInsightsHubArticleById = createAsyncThunk<InsightsHubArticle, string, ThunkApiConfig>(
  "insightsHub/fetchInsightsHubArticleById",
  async (articleId, { dispatch, rejectWithValue, getState }) => {
    try {
      const documentId = resolveInsightsHubArticleDocumentId(articleId, getState().insightsHub.data);
      const response = await dispatch(callInsightsHubArticleApi(documentId));

      if (response?.data == null) {
        dispatch(openNotificationThunk({ variant: "warning", text: "Failed to load article" }));

        return rejectWithValue("Article not found");
      }

      return mapStrapiPortalArticle(response.data);
    } catch (error) {
      console.error(error);

      dispatch(openNotificationThunk({ variant: "warning", text: "Failed to load article" }));

      return rejectWithValue("Failed to fetch");
    }
  }
);
